import type {
  ListaSubestipulanteItem,
  ListaSubestipulantesGroup,
  ListaSubestipulantesResponse,
} from '../../types/vida/subEstipulante/subEstipulanteType';
import { VIDA_LIST_SUBESTIPULANTES_ROUTES } from '../requestsService';

/** Normaliza resposta do BFF (array na raiz ou um único grupo). */
export function flattenListaSubestipulantesResponse(
  res: ListaSubestipulantesResponse | ListaSubestipulantesGroup,
): ListaSubestipulanteItem[] {
  const arr: ListaSubestipulantesGroup[] = Array.isArray(res) ? res : [res];
  return arr.flatMap((g) => g.retorno ?? []).filter((x): x is ListaSubestipulanteItem => x != null);
}

function buildQueryString(params: Record<string, string | number | undefined>): string {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== '') {
      search.append(key, String(value));
    }
  });
  const qs = search.toString();
  return qs ? `?${qs}` : '';
}

export class SubEstipulanteService {
  private fetch: <T>(endpoint: string, options?: RequestInit) => Promise<T>;

  constructor(fetch: <T>(endpoint: string, options?: RequestInit) => Promise<T>) {
    this.fetch = fetch;
  }

  /**
   * Lists subestipulantes for a contract (GET obter-lista-subestipulantes).
   * @param identContrato - Contract id (required)
   */
  async getListaSubestipulantes(identContrato: number): Promise<ListaSubestipulantesResponse> {
    const url =
      VIDA_LIST_SUBESTIPULANTES_ROUTES.GET_LIST_SUBESTIPULANTES +
      buildQueryString({ identContrato });
    return this.fetch<ListaSubestipulantesResponse>(url, { method: 'GET' });
  }
}
